/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Drawer,
  FormGroup,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { isValidNumber } from "../utils/validations";

interface OfferFiltersProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  setEndDate: (date: Dayjs | null) => void;
  handleSubmit?: (clearData?: any) => void;
  handleClearFilters: () => void;
  isButterflyEffect: boolean;
  setIsButterflyEffect: (value: boolean) => void;
  isCancellationPolicy: boolean;
  setIsCancellationPolicy: (value: boolean) => void;
  popularOffer: boolean;
  setPopularOffer: (value: boolean) => void;
  tags: any[];
  selectedTags: string[];
  setSelectedTags: (value: string[]) => void;
  groups: any[];
  selectedGroups: string[];
  setSelectedGroups: (value: string[]) => void;
  eventType: string;
  setEventType: (value: string) => void;
  offerType: string;
  setOfferType: (value: string) => void;
  nonMemberPrice: string;
  setNonMemberPrice: (value: string) => void;
  memberPrice: string;
  setMemberPrice: (value: string) => void;
  selectedTagsId: string[];
  setSelectedTagsId: (value: string[]) => void;
  selectedGroupsId: string[];
  setSelectedGroupsId: (value: string[]) => void;
}

function OfferFilters({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSubmit,
  handleClearFilters,
  isButterflyEffect,
  setIsButterflyEffect,
  isCancellationPolicy,
  setIsCancellationPolicy,
  popularOffer,
  setPopularOffer,
  tags,
  selectedTags,
  setSelectedTags,
  groups,
  selectedGroups,
  setSelectedGroups,
  eventType,
  setEventType,
  offerType,
  setOfferType,
  nonMemberPrice,
  setNonMemberPrice,
  memberPrice,
  setMemberPrice,
  selectedTagsId,
  setSelectedTagsId,
  selectedGroupsId,
  setSelectedGroupsId,
}: OfferFiltersProps) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };

  const handleClearAll = () => {
    setStartDate(null);
    setEndDate(null);
    setOpenDrawer(false);
    handleSubmit?.(true);
    handleClearFilters();
  };

  const handleGroupChange = (event: any, value: any[]) => {
    const selectedNames = value?.map((group) => group?.name);
    setSelectedGroups(selectedNames);
    const selectedIds = value?.map((group) => group?.id);
    setSelectedGroupsId(selectedIds);
  };
  const handleTagChange = (event: any, value: any[]) => {
    const selectedNames = value?.map((group) => group?.name);
    setSelectedTags(selectedNames);
    const selectedIds = value?.map((group) => group?.id);
    setSelectedTagsId(selectedIds);
  };

  return (
    <>
      <Button onClick={toggleDrawer(true)} className="btn btn_primary">
        <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
      </Button>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          handleClearAll();
        }}
        className="filter_drawer"
      >
        <div style={{ width: 420, padding: 20 }} className="filter_body">
          <div
            className="filter_head"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <h3>Filters</h3>
            <a onClick={handleClearAll} style={{ cursor: "pointer" }}>
              Clear All
            </a>
          </div>

          <div className="gap_m">
            <>
              <div className="w_50 control_group date_field">
                <label>Select Start Range</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    format="DD/MM/YYYY"
                    value={startDate}
                    slotProps={{
                      textField: {
                        placeholder: "Start Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    onChange={(newValue) => setStartDate?.(newValue)}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      // textField: (params) => (
                      //   <TextField
                      //     {...params}
                      //     fullWidth
                      //     placeholder="Start Date"
                      //     hiddenLabel
                      //   />
                      // ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="w_50 control_group date_field">
                <label>Select End Range</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    value={endDate}
                    onChange={(newValue) => setEndDate?.(newValue)}
                    minDate={dayjs(startDate)}
                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        placeholder: "End Date",
                        sx: {
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#9999", // change text & placeholder color
                            opacity: 1,
                          },
                        },
                      },
                    }}
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                    disabled={!startDate}
                  />
                </LocalizationProvider>
              </div>

              <div className="control_group w_100">
                <label>Groups</label>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={groups}
                  value={groups?.filter((option) =>
                    selectedGroupsId?.includes(option?.id)
                  )}
                  onChange={handleGroupChange}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.id === value?.id
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderOption={(props, option: any, { selected }) => {
                    return (
                      <li {...props}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Groups" />
                  )}
                />
              </div>

              <div className="control_group w_100">
                <label>Tags</label>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={tags}
                  value={tags?.filter((option) =>
                    selectedTagsId?.includes(option?.id)
                  )}
                  onChange={handleTagChange}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?.id === value?.id
                  }
                  onOpen={() => setAutoCompleteOpen(true)}
                  onClose={() => setAutoCompleteOpen(false)}
                  renderOption={(props, option: any, { selected }) => {
                    return (
                      <li {...props}>
                        <FormControlLabel
                          control={<Checkbox checked={selected} />}
                          name="option"
                          label={option?.name}
                        />
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select Tags" />
                  )}
                />
              </div>

              <div className="control_group w_50">
                <label>Event Type</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={eventType}
                  onChange={(e) => setEventType(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select Event Type
                  </MenuItem>

                  <MenuItem value="Paid"> Paid</MenuItem>
                  <MenuItem value="Complimentary">Complimentary</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label>Offer Type</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={offerType}
                  onChange={(e) => setOfferType(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select Offer Type
                  </MenuItem>

                  <MenuItem value="Restaurant"> Restaurant</MenuItem>
                  <MenuItem value="Events">Events</MenuItem>
                  <MenuItem value="Contact Dealers">Contact Dealers</MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                </Select>
              </div>

              <div className="control_group w_100">
                <TextField
                  id="amount"
                  placeholder="Member Price"
                  fullWidth
                  hiddenLabel
                  inputProps={{ maxLength: 10 }}
                  value={memberPrice}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setMemberPrice(value);
                    }
                  }}
                />
              </div>

              <div className="control_group w_100">
                <TextField
                  id="amount"
                  placeholder="Non-Member Price"
                  fullWidth
                  hiddenLabel
                  inputProps={{ maxLength: 10 }}
                  value={nonMemberPrice}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setNonMemberPrice(value);
                    }
                  }}
                />
              </div>

              <div className="control_group ">
                <FormGroup
                  className="paid_checkbox"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isButterflyEffect}
                        onChange={() =>
                          setIsButterflyEffect(!isButterflyEffect)
                        }
                      />
                    }
                    label="Butterfly Effect"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isCancellationPolicy}
                        onChange={() =>
                          setIsCancellationPolicy(!isCancellationPolicy)
                        }
                      />
                    }
                    label="Cancellation Policy"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={popularOffer}
                        onChange={() => setPopularOffer(!popularOffer)}
                      />
                    }
                    label="Popular Offer"
                  />
                </FormGroup>
              </div>
            </>
          </div>

          <div className="btn_flex">
            <Button
              className="btn btn_primary"
              onClick={() => {
                if (handleSubmit) {
                  handleSubmit();
                }
                setOpenDrawer(false);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default OfferFilters;
